import { MessageCircle } from 'lucide-react';
import ComingSoonLayout from '../components/ComingSoonLayout';

const MessagesPlaceholder = () => (
  <ComingSoonLayout
    icon={MessageCircle}
    headline="Messaging is coming soon."
    body="Soon you'll be able to chat directly with verified landlords from inside Sturent — share documents, ask questions, and schedule a visit."
    footnote="We'll let you know the moment it's live."
    testId="messages-placeholder"
  />
);

export default MessagesPlaceholder;
